module.exports = __webpack_public_path__ + "img/princeton.c94fda60.png";